/*
 * Dialog
 */
import { retainFocus } from "@sitebuilder/utils/dom.js";
import { getSeverityIcon } from "@sitebuilder/utils/ui.js";

const onKeydown = (node) => (e) => {
  if (e.code === "Escape" && node.dataset.closeOnEscape) {
    node.hide();
  }
  if (e.keyCode === 9) {
    // tab
    retainFocus(event, node);
  }
};

const onAnimationEnd = (node) => {
  const keydown = onKeydown(node);
  return (e) => {
    if (e.target !== node) return;

    // on hide
    if (node.__isHidding) {
      node.__isHidding = false;
      node.classList.remove("a-dialog-visible");
      window.document.removeEventListener("keydown", keydown);
    } else {
      window.document.addEventListener("keydown", keydown);
    }
  };
};

const attachDialog = (node) => {
  (document.querySelector(node.dataset.appendTo) || document.body).appendChild(node);

  // Set default settings
  const ds = node.dataset;
  if (typeof ds.closeOnEscape === "undefined") {
    ds.closeOnEscape = true;
  }

  const boxNode = node.querySelector(".a-dialog-box");

  node.show = () => {
    node.__isHidding = false;

    node.classList.add("fadeIn");
    node.classList.remove("fadeOut");
    node.classList.add("a-dialog-visible");

    boxNode.classList.add(node.dataset.openingAnimation);
    boxNode.classList.remove(node.dataset.closingAnimation);

    node.dispatchEvent(new Event("show"));
  };

  node.hide = () => {
    node.__isHidding = true;

    node.classList.remove("fadeIn");
    node.classList.add("fadeOut");
    node.classList.add("a-dialog-visible");

    boxNode.classList.add(node.dataset.closingAnimation);
    boxNode.classList.remove(node.dataset.openingAnimation);

    node.dispatchEvent(new Event("hide"));
  };

  /// Header close handler
  const closeNode = node.querySelector(".a-dialog-header-close-icon");
  closeNode && closeNode.parentNode.addEventListener("click", (e) => {
    node.hide();
    e.preventDefault();
    e.stopPropagation();
    return false;
  });

  /// onhide need to wait for animationEnd()
  node.addEventListener("animationend", onAnimationEnd(node));
};

const createDialog = (attributes) => {};

const razorDialog = {
  selector: ".a-dialog",
  create: createDialog,
  attach: attachDialog,
};

export function alertDialog(title, message, severity) {

  return new Promise((resolve) => {
    const parser = new DOMParser();
    const id = "__alert-diag__";
    const existant = document.getElementById(id);
    if (existant) {
      existant.remove();
    }
    severity = severity || "danger";
    const doc = parser.parseFromString(
      '<div id="' +
        id +
        `" class="a-dialog a-dialog-visible fadeIn" data-append-to="body" data-opening-animation="fadeIn" data-closing-animation="fadeOut" data-close-on-escape="true"><div class="a-dialog-box fadeIn"><div class="a-dialog-box-wrapper "><div class="a-dialog-header"><span class="a-dialog-title"><span style="color:var(--${severity}-color)"><i class="${getSeverityIcon(
          severity,
        )}" style="font-size:2rem;"></i> ` +
        title +
        '</span></span><button class="a-dialog-header-icon" type="button" aria-label="Close"><span class="a-dialog-header-close-icon ico ico-times"></span></button></div><div class="a-dialog-content">' +
        message +
        '</div></div><div class="a-dialog-footer"><button onclick="document.getElementById(\'' +
        id +
        '\').hide();" type="button" class="a-button a-button" aria-label="Fermer"><span class="a-button-label">Fermer</span></button></div></div></div>',
      "text/html",
    );
    const node = doc.getElementById(id);
    document.body.appendChild(node);
    attachDialog(node);
    node.addEventListener("hide", resolve);
  });

}

export default razorDialog;
